import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface ModalConfirmacaoExcluirProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  codigo: string;
  descricao: string;
  loading?: boolean;
}

export const ModalConfirmacaoExcluir: React.FC<ModalConfirmacaoExcluirProps> = ({
  open,
  onClose,
  onConfirm,
  codigo,
  descricao,
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6" sx={{ color: "#4a4a4a", fontWeight: 600 }}>
            Excluir superfície
          </Typography>
          <IconButton onClick={onClose} size="small" disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ textAlign: "center", py: 2 }}>
          <WarningAmberIcon sx={{ fontSize: 48, color: "#ff9800", mb: 2 }} />
          
          <Typography variant="body1" sx={{ mb: 2 }}>
            Tem certeza que deseja excluir esta superfície?
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              backgroundColor: "#f5f5f5",
              p: 2,
              borderRadius: 1,
            }}
          >
            {codigo} - {descricao}
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Esta ação não pode ser desfeita.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, justifyContent: "center", gap: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{
            minWidth: 120,
            borderColor: "#999",
            color: "#666",
            "&:hover": { borderColor: "#666", backgroundColor: "#f5f5f5" },
          }}
        >
          CANCELAR
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{
            minWidth: 120,
            backgroundColor: "#d32f2f",
            "&:hover": { backgroundColor: "#b71c1c" },
          }}
        >
          {loading ? "EXCLUINDO..." : "EXCLUIR"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
